var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddDepartmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4847",
    "data-name": "Group 4847",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.186,
    height: 73.622,
    viewBox: "0 0 59.186 73.622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1202",
    "data-name": "Rectangle 1202",
    width: 59.186,
    height: 73.622,
    fill: "#1da193"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1196",
    "data-name": "Rectangle 1196",
    width: 23.307,
    height: 51.374,
    fill: "#1da193"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1197",
    "data-name": "Rectangle 1197",
    width: 20.776,
    height: 51.425,
    fill: "#1da193"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1198",
    "data-name": "Rectangle 1198",
    width: 21.389,
    height: 51.425,
    fill: "#1da193"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1199",
    "data-name": "Rectangle 1199",
    width: 14.848,
    height: 14.848,
    fill: "#1da193"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4846",
    "data-name": "Group 4846",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4830",
    "data-name": "Group 4830",
    transform: "translate(18.074 22.248)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4829",
    "data-name": "Group 4829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4828",
    "data-name": "Group 4828",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7748",
    "data-name": "Path 7748",
    d: "M72.937,67.323V84.354a1.061,1.061,0,0,1-.31.744,8.716,8.716,0,0,1-3.965,2.15,1.045,1.045,0,0,0-.784,1.007v22.334a1.045,1.045,0,0,1-.369.8,7.356,7.356,0,0,1-1.516.976,1.034,1.034,0,0,1-.454.1H57.1a1.034,1.034,0,0,1-.477-.113,7.287,7.287,0,0,1-1.6-1.117,1.054,1.054,0,0,1-.338-.771V88.175a1.05,1.05,0,0,0-.844-1.021,5.153,5.153,0,0,1-4.165-3.437,1.051,1.051,0,0,1-.05-.326V66.841a1.032,1.032,0,0,1,.059-.353,8.575,8.575,0,0,1,4.792-4.672c.069-.033.138-.058.208-.087a9.138,9.138,0,0,1,3.325-.637h.07a1.03,1.03,0,0,1,.767.361l.956,1.106,0,0,.729.847a1.041,1.041,0,0,0,1.578,0L62.471,63l.32-.371L63.8,61.456a1.044,1.044,0,0,1,.769-.363l.2,0a8.146,8.146,0,0,1,3.11.626l.026.011A8.76,8.76,0,0,1,72.9,67.022a1.061,1.061,0,0,1,.042.3",
    transform: "translate(-49.63 -61.091)",
    fill: "#1da193"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4833",
    "data-name": "Group 4833",
    transform: "translate(38.409 17.369)",
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4832",
    "data-name": "Group 4832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4831",
    "data-name": "Group 4831",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7749",
    "data-name": "Path 7749",
    d: "M126.246,53.051V70.905a1,1,0,0,1-.1.437,4.545,4.545,0,0,1-.269.48,4.7,4.7,0,0,1-3.379,2.054,1.035,1.035,0,0,0-.871,1.025V97.194a1.048,1.048,0,0,1-.377.8,7.47,7.47,0,0,1-1.651,1.029,1.041,1.041,0,0,1-.436.093h-8.15l-.464-.106a7.423,7.423,0,0,1-1.774-1.219,1.06,1.06,0,0,1-.339-.772V79.79a1.032,1.032,0,0,1,.437-.845,5.843,5.843,0,0,0,1.731-1.829,1,1,0,0,0,.127-.5V58.555a1.055,1.055,0,0,0-.043-.3,13.9,13.9,0,0,0-2.251-4.338,10.292,10.292,0,0,0-2.5-2.382,1.04,1.04,0,0,1-.094-1.677,9.657,9.657,0,0,1,2.591-1.517,9.136,9.136,0,0,1,2.294-.575,8.188,8.188,0,0,1,1.038-.066,5.969,5.969,0,0,1,.626.029h0l1.173,1.362.8.926a1.041,1.041,0,0,0,1.576,0l.647-.751,1.038-1.2a1.028,1.028,0,0,1,.775-.361h0a8.182,8.182,0,0,1,3.216.67,9.021,9.021,0,0,1,4.516,4.238,1.029,1.029,0,0,1,.1.447",
    transform: "translate(-105.47 -47.696)",
    fill: "#1da193"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4836",
    "data-name": "Group 4836",
    transform: "translate(0 17.369)",
    style: {
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4835",
    "data-name": "Group 4835"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4834",
    "data-name": "Group 4834",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7750",
    "data-name": "Path 7750",
    d: "M16.315,57.743V76.637a1.008,1.008,0,0,0,.1.455,5.656,5.656,0,0,0,1.318,1.677,1.021,1.021,0,0,1,.339.766V97.108a1.047,1.047,0,0,1-.355.786,7.211,7.211,0,0,1-1.4.953q-.18.1-.366.182a1.02,1.02,0,0,1-.43.091H7.361a1.038,1.038,0,0,1-.461-.1,7.439,7.439,0,0,1-1.666-1.121,1.054,1.054,0,0,1-.351-.783V74.756a1.05,1.05,0,0,0-.794-1.01A5.151,5.151,0,0,1,.269,70.711,4.6,4.6,0,0,1,0,69.112a3.763,3.763,0,0,1,.2-1.274,1.125,1.125,0,0,0,.073-.38V53.565a1.044,1.044,0,0,1,.058-.352A8.281,8.281,0,0,1,4.884,48.58a7.617,7.617,0,0,1,2.953-.6c.219,0,.434.009.648.027a1.055,1.055,0,0,1,.715.36l.92,1.067.5.583a1.041,1.041,0,0,0,1.577,0l.465-.541,1.191-1.382a1.061,1.061,0,0,1,.713-.359q.359-.032.725-.032a7.268,7.268,0,0,1,1.02.073,7.491,7.491,0,0,1,1.759.462A8.51,8.51,0,0,1,21.1,50.257a1.038,1.038,0,0,1-.314,1.658,8.858,8.858,0,0,0-2.714,1.938,5.839,5.839,0,0,0-1.759,3.889",
    transform: "translate(0 -47.695)",
    fill: "#1da193"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4839",
    "data-name": "Group 4839",
    transform: "translate(4.055)",
    style: {
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4838",
    "data-name": "Group 4838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4837",
    "data-name": "Group 4837",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7751",
    "data-name": "Path 7751",
    d: "M25.982,7.424A7.424,7.424,0,1,1,18.558,0a7.424,7.424,0,0,1,7.424,7.424",
    transform: "translate(-11.134)",
    fill: "#1da193"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4842",
    "data-name": "Group 4842",
    transform: "translate(22.413 4.912)",
    style: {
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4841",
    "data-name": "Group 4841"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4840",
    "data-name": "Group 4840",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7752",
    "data-name": "Path 7752",
    d: "M76.392,20.912a7.424,7.424,0,1,1-7.424-7.424,7.424,7.424,0,0,1,7.424,7.424",
    transform: "translate(-61.544 -13.488)",
    fill: "#1da193"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4845",
    "data-name": "Group 4845",
    transform: "translate(40.712)",
    style: {
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4844",
    "data-name": "Group 4844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4843",
    "data-name": "Group 4843",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7753",
    "data-name": "Path 7753",
    d: "M126.642,7.424A7.424,7.424,0,1,1,119.218,0a7.424,7.424,0,0,1,7.424,7.424",
    transform: "translate(-111.794)",
    fill: "#1da193"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDepartmentIcon);
export default __webpack_public_path__ + "static/media/addDepartment_icon.166393f4960b74c715656dc86682688b.svg";
export { ForwardRef as ReactComponent };